import { HttpClient, HttpStatusCode } from '@/data/protocols/http'
import { BadRequestError, ForbiddenError, UnexpectedError, UnexpectedResultFormatError } from '@/domain/errors'
import { SaveCreditCardByToken, SaveCreditCardByTokenParams } from '@/domain/usecases'

export class RemoteSaveCreditCardByToken implements SaveCreditCardByToken {
  constructor (
    private readonly url: string,
    private readonly httpClient: HttpClient<string>
  ) {}

  async save (params: SaveCreditCardByTokenParams): Promise<string> {
    const { expiracao, ...rest } = params.card

    const { statusCode, body } = await this.httpClient.request({
      method: 'post',
      url: `${this.url}/api/portal/cadastrar-cartao-token/${params.token}`,
      body: {
        ...rest,
        expiracao: this.formatExpiration(expiracao)
      }
    })

    switch (statusCode) {
      case HttpStatusCode.ok:
        if (!body) {
          throw new UnexpectedResultFormatError()
        }
        return body
      case HttpStatusCode.forbidden: throw new ForbiddenError(body)
      case HttpStatusCode.badRequest: throw new BadRequestError(body)
      default: throw new UnexpectedError()
    }
  }

  formatExpiration (expiration: string): string {
    const currentYear = new Date()
      .getFullYear()
      .toString()
      .substring(0, 2)

    return `${expiration.split('/')[0]}/${currentYear}${expiration.split('/')[1]}`
  }
}
